import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    dummyPressItem,
    TeaserPressTemplate,
    TeaserPressOneColumnTemplate,
    TeaserPressTwoColumnsTemplate,
} from "./teaser-press.templates";

export default {
    title: "Website/Partial Templates/Teaser/Press",
    render: TeaserPressTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: { ...dummyPressItem },
};

export const Default = {};

export const OneColumn = {
    render: TeaserPressOneColumnTemplate.bind({}),
};

export const TwoColumns = {
    render: TeaserPressTwoColumnsTemplate.bind({}),
};
